import { Button, Stack } from "@mui/material";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";

const CandidateTransferHeader = ({ onOpenModal }) => {
  return (
    <Stack direction="row" spacing={2}>
      <Button variant={"contained"} color="primary" onClick={() => onOpenModal("COPY")} startIcon={<DoubleArrowIcon />} sx={{ height: 40 }}>
        New Copy
      </Button>
      <Button variant={"contained"} color="secondary" onClick={() => onOpenModal("MOVE")} startIcon={<SwapHorizIcon />} sx={{ height: 40 }}>
        New Move
      </Button>
    </Stack>
  );
};

export default CandidateTransferHeader;
